import * as StoreLocatorInput from './merchants_lookup';
import * as AddressAutocompleteInput from './address_lookup_autocomplete';
import { Loader } from "@googlemaps/js-api-loader"

export function init(form_container) {
  const loader = new Loader({
    apiKey: "AIzaSyCUWJl7RunCRx9bW0ZOa99jNoa9BrTRlGQ",
    libraries: ["places"],
  });
  loader.load().then(() => {
    StoreLocatorInput.init(form_container);
    AddressAutocompleteInput.init(form_container);
  });
}
